<template>
  <transition name="modal-fade">
    <div class="modal-mask" @click.self="handleClose">
      <div class="modal-wrapper">
        <div class="modal-dialog">
          <div class="modal-content rounded-8">
            
            <ModalHeader 
              title="Eliminar Usuario"
              @close="handleClose"
            />
            
            <ModalBody>
              <ConfirmationMessage
                :student="student"
                :loading="loading"
              />
            </ModalBody>
            
            <ModalFooter>
              <div class="d-flex justify-content-center gap-3 w-100">
                <button 
                  type="button" 
                  class="btn text-primary bg-utel-v2-secondary" 
                  @click="handleClose"
                  :disabled="loading"
                >
                  Cancelar
                </button>
                
                <button 
                  type="button" 
                  class="btn text-white bg-danger" 
                  @click="handleDelete"
                  :disabled="loading"
                >
                  {{ loading ? 'Eliminando...' : 'Eliminar usuario' }}
                </button>
              </div>
            </ModalFooter>
            
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { useStudentApi } from '../../composables/useStudentApi.js'
import { useNotifications } from '../../composables/useNotifications.js'
import ModalHeader from './components/ModalHeader.vue'
import ModalBody from './components/ModalBody.vue'
import ModalFooter from './components/ModalFooter.vue'
import ConfirmationMessage from './components/ConfirmationMessage.vue'

export default {
  name: 'ModalDeleteStudent',
  
  components: {
    ModalHeader,
    ModalBody,
    ModalFooter,
    ConfirmationMessage
  },

  props: {
    student: { type: Object, required: true },
    url: { type: String, required: true }
  },

  emits: ['close', 'success'],

  setup(props, { emit }) {
    const { loading, deleteStudent } = useStudentApi()
    const { notifyStudentDeleted, notifyError } = useNotifications()

    const handleDelete = async () => {
      if (loading.value) return

      try {
        await deleteStudent(props.url, props.student.id)
        
        emit('success')
        handleClose()
        
        await notifyStudentDeleted()
      } catch (error) {
        console.error('Error deleting student:', error)
        notifyError('Error al eliminar el colaborador')
      }
    }

    const handleClose = () => {
      if (!loading.value) {
        emit('close')
      }
    }

    return {
      loading,
      handleDelete,
      handleClose
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  width: 100%;
  max-width: 400px;
  margin: 0 20px;
}

.modal-dialog {
  width: 100%;
}

.modal-content {
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from, .modal-fade-leave-to {
  opacity: 0;
}
</style>